import { useEffect, useState } from 'react';
import {
  useFieldArray,
  useFormState,
  useWatch,
  type UseControllerProps,
  type UseFormSetValue,
} from 'react-hook-form';
import { MAP_PLACEHOLDERS, type ContactType } from '@widgets/contacts/contact-edit/constans.tsx';
import { SelectType } from '@features/contacts/index.ts';
import { Close } from '@shared/assets/index.ts';
import { FormFieldWithLabelAndPlusBtn } from '@shared/ui/forms/FieldWithLabel/index.ts';
import { Card, IconButton, TextInputM } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

type ContactsArrayEditorT = UseControllerProps<any> & {
  label?: string;
  setValue: UseFormSetValue<any>;
};

export const ContactsArrayEditor = ({
  label = 'Контакты',
  setValue,
  ...rest
}: ContactsArrayEditorT) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { name } = rest;
  const contacts = useWatch(rest);
  const { fields, remove, prepend, replace } = useFieldArray(rest);
  const { errors } = useFormState(rest);

  useEffect(() => {
    if (contacts.length && !isInitialized) {
      replace(contacts);
      setIsInitialized(true);
    }
  }, [isInitialized, contacts, replace]);

  const addContact = () => {
    prepend({ type: 'phone', value: '' });
  };

  const getError = (index: number) => {
    const fieldError = errors[name];
    if (Array.isArray(fieldError) && fieldError[index]?.value?.message) {
      return fieldError[index].value.message;
    }
    return '';
  };

  return (
    <FormFieldWithLabelAndPlusBtn
      label={label}
      onBtnClick={addContact}
      withBigButton={!fields?.length}
    >
      {fields.map((field, index) => (
        <Card key={field.id} className={st.contact}>
          <SelectType
            wrapperClassName={st.select}
            contactOption={contacts[index]?.type}
            setContactOption={(type) => setValue(`${name}.${index}.type`, type)}
          />
          <TextInputM
            className={st.input}
            labelClassName={st.valueLabel}
            label={'URL / телефон'}
            placeholder={MAP_PLACEHOLDERS[contacts[index]?.type as ContactType]}
            value={contacts[index]?.value || ''}
            onChange={(e) => setValue(`${name}.${index}.value`, e.target.value)}
            error={getError(index)}
          />
          <IconButton
            variant={'white'}
            type={'button'}
            onClick={() => remove(index)}
            className={st.deleteButton}
          >
            <Close />
          </IconButton>
        </Card>
      ))}
    </FormFieldWithLabelAndPlusBtn>
  );
};
